// Styles
import '../css/_material.scss';

// Components
import { MDCTextField } from '@material/textfield';
import { MDCFormField } from '@material/form-field';
import { MDCCheckbox } from '@material/checkbox';
import { MDCRadio } from '@material/radio';
import { MDCSelect } from '@material/select';
import { MDCSwitch } from '@material/switch';
import { MDCRipple } from '@material/ripple';
import { MDCTopAppBar } from '@material/top-app-bar';
import { MDCSnackbar } from '@material/snackbar';
import { MDCDrawer } from '@material/drawer';
import { MDCTabBar } from '@material/tab-bar';
import { MDCSlider } from '@material/slider';

// Expose
window.MDCTextField = MDCTextField;
window.MDCFormField = MDCFormField;
window.MDCCheckbox = MDCCheckbox;
window.MDCRadio = MDCRadio;
window.MDCSelect = MDCSelect;
window.MDCSwitch = MDCSwitch;
window.MDCRipple = MDCRipple;
window.MDCTopAppBar = MDCTopAppBar;
window.MDCSnackbar = MDCSnackbar;
window.MDCDrawer = MDCDrawer;
window.MDCTabBar = MDCTabBar;
window.MDCSlider = MDCSlider;
